export default {
  getDefaultState: () => {
    return {
      categories: [],
      customCategories: [],
      defaultCategoriesOffice: [],
      userRecentCategories: [],
      filters: {},
      currentPage: 1,
      lastPage: 1,
      isCallingCategories: false
    }
  }
}
